import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Target, TrendingUp, Shield } from 'lucide-react';

const About = () => {
  const { t, language } = useLanguage();

  const values = [
    {
      icon: Target,
      title: language === 'pt' ? 'Foco em Resultados' : 'Results Focused',
      description: language === 'pt' ? 'Entregamos soluções tangíveis que impactam diretamente seus resultados' : 'We deliver tangible solutions that directly impact your results'
    },
    {
      icon: TrendingUp,
      title: language === 'pt' ? 'Eficiência Operacional' : 'Operational Efficiency',
      description: language === 'pt' ? 'Otimizamos processos para máxima produtividade' : 'We optimize processes for maximum productivity'
    },
    {
      icon: Shield,
      title: language === 'pt' ? 'Confiabilidade' : 'Reliability',
      description: language === 'pt' ? 'Mais de uma década de expertise e confiança' : 'Over a decade of expertise and trust'
    }
  ];

  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80"
                alt="Corporate workspace"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative element */}
            <div
              className="absolute -top-6 -left-6 w-48 h-48 rounded-full blur-3xl opacity-20"
              style={{ backgroundColor: '#45C1E0' }}
            ></div>
          </div>

          {/* Content */}
          <div className="space-y-6 order-1 lg:order-2">
            <div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6" style={{ color: '#193B7F' }}>
                {t.about.title}
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                {t.about.text}
              </p>
            </div>

            {/* Values */}
            <div className="space-y-6 pt-8">
              {values.map((value, index) => (
                <div key={index} className="flex items-start space-x-4 group">
                  <div
                    className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center transition-transform duration-200 group-hover:scale-110"
                    style={{ backgroundColor: '#45C1E0' }}
                  >
                    <value.icon className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1" style={{ color: '#193B7F' }}>
                      {value.title}
                    </h3>
                    <p className="text-gray-600">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
